module.exports = __webpack_public_path__ + "media/project_quote/Info-d093bae4.svg";